// object/index.ts
function isObject(obj: any): boolean {
  return obj !== null && typeof obj === 'object';
}

export function deepEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) {
    return true;
  }

  if (!isObject(obj1) || !isObject(obj2)) {
    return false;
  }

  if (Array.isArray(obj1) !== Array.isArray(obj2)) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!keys2.includes(key)) {
      return false;
    }

    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export const isEmpty = (value: any): boolean => {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }

  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};

export const set = (obj: any, path: string | string[], value: any): any => {
  if (obj == null) {
    return obj;
  }

  const pathArray = Array.isArray(path)
    ? path
    : path.toString().match(/[^.[\]]+/g) || [];

  pathArray.reduce((acc, key, i) => {
    if (i === pathArray.length - 1) {
      acc[key] = value;
    } else {
      acc[key] =
        acc[key] === undefined
          ? !isNaN(Number(pathArray[i + 1]))
            ? []
            : {}
          : acc[key];
    }
    return acc[key];
  }, obj);

  return obj;
};

export const cloneDeep = <T>(value: T): T => {
  // Handle primitive types and null/undefined
  if (value === null || value === undefined || typeof value !== 'object') {
    return value;
  }

  // Handle Date
  if (value instanceof Date) {
    return new Date(value.getTime()) as unknown as T;
  }

  // Handle Array
  if (Array.isArray(value)) {
    return value.map((item) => cloneDeep(item)) as unknown as T;
  }

  // Handle regular Objects
  const clone = {} as T;
  Object.keys(value as object).forEach((key) => {
    (clone as any)[key] = cloneDeep((value as any)[key]);
  });

  return clone;
};
